<template>
  <div>
    <template v-if="priceType == 'unitPrice'">
      <Poptip placement="bottom" width="400" ref="poptipModal">
        <span> {{ text }} </span>
        <template #content>
          <div class="modal_content">
            <div class="unitPrice">
              单价：<Input v-model="unitPrice" placeholder="请输入价格" style="width: 200px" />
            </div>
            <div class="modal_content_btn">
              <Button type="primary" class="modal_content_btn_ok" @click="onModalSubmit">确定</Button>
            </div>
          </div>
        </template>
      </Poptip>
    </template>
    <template v-if="priceType == 'jdPrice'">
      <Poptip placement="bottom" width="400" ref="poptipModal">
        <span> {{ text }} </span>
        <template #content>
          <div class="modal_content">
            <div class="unitPrice">
              进货价：<Input v-model="jdPrice" placeholder="请输入进货价" style="width: 200px" />
            </div>
            <div class="modal_content_btn">
              <Button type="primary" class="modal_content_btn_ok" @click="onModalSubmit">确定</Button>
            </div>
          </div>
        </template>
      </Poptip>
    </template>
    <template v-if="priceType == 'payState'">
      <Poptip placement="bottom" width="400" ref="poptipModal">
        <span :style="text == 1 ? 'color:green;' : text == 2 ? 'color:red;' : ''">{{ text === 1 ? "已付款" : text === 2 ?
          "未付款" : ""
          }}</span>
        <template #content>
          <div class="modal_content">
            <div class="unitPrice">
              付款状态：
              <Select v-model="payState" style="width: 200px">
                <Option v-for="item in List" :value="item.value" :key="item.value">{{
                  item.label
                }}</Option>
              </Select>
            </div>
            <div class="modal_content_btn">
              <Button type="primary" class="modal_content_btn_ok" @click="onSubmitPayState">确定</Button>
            </div>
          </div>
        </template>
      </Poptip>
    </template>
  </div>
</template>

<script>
export default {
  props: ["text", "item", "priceType"],
  data() {
    return {
      unitPrice: "",
      jdPrice: "",
      payState: "",
      List: [
        { label: "已付款", value: 1 },
        { label: "未付款", value: 2 },
      ],
    };
  },
  created() {
    if (this.priceType == "unitPrice") {
      this.unitPrice = this.text;
    }
    if (this.priceType == "jdPrice") {
      this.jdPrice = this.text;
    }
    if (this.priceType == "payState") {
      this.payState = this.text;
    }
  },
  methods: {
    async onSubmitPayState() {
      console.log(this.item);

      let q = this.item
      q.payState = this.payState
      let res = await $utils.api.load('/admin/system/procurementContract', q, 'PUT')
      console.log(res);
      if (res.code == 200) {
        this.$refs.poptipModal.handleClose();
        $utils.toast.success("修改成功！");
        this.$emit("Reset");
      }

    },
    async onModalSubmit() {
      let q = {};
      // console.log(this.item);
      if (this.priceType == "unitPrice") {
        if (!this.unitPrice) {
          $utils.toast.success("请输入价格！");
          return;
        }
        q = this.item;
        q.unitPrice = this.unitPrice;
      }
      if (this.priceType == "jdPrice") {
        if (!this.jdPrice) {
          $utils.toast.success("请输入进货价！");
          return;
        }
        q = this.item;
        q.jdPrice = this.jdPrice;
        q.unitPrice = this.jdPrice * 1.3;
      }
      let res = await $utils.api.load("/admin/system/inventory", q, "PUT");
      if (res.code == 200) {
        this.$refs.poptipModal.handleClose();
        $utils.toast.success("修改成功！");
        this.$emit("Reset");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.modal_content {
  padding: 20px;

  .unitPrice {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
  }

  .modal_content_btn {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>
